import { render, staticRenderFns } from "./officialAccountSet.vue?vue&type=template&id=fafadba2&scoped=true&"
import script from "./officialAccountSet.vue?vue&type=script&lang=js&"
export * from "./officialAccountSet.vue?vue&type=script&lang=js&"
import style0 from "./officialAccountSet.vue?vue&type=style&index=0&id=fafadba2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafadba2",
  null
  
)

export default component.exports